/* eslint-disable max-len */
import { AftersalesOrderRequest } from '@1po/1po-bff-fe-spec/generated/aftersales_order/request/AftersalesOrderRequest';
import { CreateOrderClaimRequest } from '@1po/1po-bff-fe-spec/generated/claim/request/CreateOrderClaimRequest';
import { GetClaimAttachmentDownloadUrlRequest } from '@1po/1po-bff-fe-spec/generated/claim/request/GetClaimAttachmentDownloadUrlRequest';
import { AddCustomItemRequest } from '@1po/1po-bff-fe-spec/generated/claim/request/GetClaimAttachmentUploadUrlRequest';
import { GetGarageClaimPageRequest } from '@1po/1po-bff-fe-spec/generated/claim/request/GetGarageClaimPageRequest';
import {
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_RESPONSE,
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_RESPONSE,
  CHECKOUT_ORDER_RESPONSE,
  GET_CURRENT_DEPOSIT_RETURN_LIST_RESPONSE,
  GET_CURRENT_EXADIS_RETURN_LIST_RESPONSE,
  GET_GARAGE_CLAIM_RESPONSE,
  REMOVE_ITEMS_FROM_DEPOSIT_RETURN_LIST_RESPONSE,
  REMOVE_ITEMS_FROM_EXADIS_RETURN_LIST_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import {
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST,
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST,
  AFTERSALESORDERS_GET_URL,
  CHECKOUT_ORDER_URL,
  EXTERNAL_ORDER_LIST_GET_URL,
  GET_CLAIM_ATTACHMENT_DOWNLOAD_URL,
  GET_CLAIM_ATTACHMENT_UPLOAD_URL,
  GET_CURRENT_DEPOSIT_RETURN_LIST,
  GET_CURRENT_EXADIS_RETURN_LIST,
  GET_GARAGE_CLAIMS_URL,
  GET_GARAGE_USERS_WITH_ORDER_URL,
  GET_SEND_CLAIM_STATUS_URL,
  MY_CLIENTS_ORDER_DETAIL_GET_URL,
  MY_CLIENTS_ORDERS_GET_URL,
  ORDER_GET_BY_ID_URL,
  ORDER_LIST_DOWNLOAD_URL,
  ORDER_RE_ADD_REFERENCES_TO_BASKET,
  REMOVE_CLAIMED_ITEMS_FROM_DEPOSIT_RETURN_LIST,
  REMOVE_CLAIMED_ITEMS_FROM_EXADIS_RETURN_LIST,
  SEND_CLAIM_URL,
  SUBSCRIBE_ORDER_STATUS_UPDATES_URL,
  UNSUBSCRIBE_ORDER_STATUS_UPDATES_URL,
} from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { AddAscOrderItemToDepositReturnListRequest } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/request/AddAscOrderItemToDepositReturnListRequest';
import { GetCurrentDepositReturnListRequest } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/request/GetCurrentDepositReturnListRequest';
import { RemoveItemsFromDepositReturnListRequest } from '@1po/1po-bff-fe-spec/generated/deposit_return_list/request/RemoveItemsFromDepositReturnListRequest';
import { AddAscOrderItemToExadisReturnListRequest } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/request/AddAscOrderItemToExadisReturnListRequest';
import { GetCurrentExadisReturnListRequest } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/request/GetCurrentExadisReturnListRequest';
import { RemoveItemsFromExadisReturnListRequest } from '@1po/1po-bff-fe-spec/generated/exadis_return_list/request/RemoveItemsFromExadisReturnListRequest';
import { MyClientsOrderDetailRequest } from '@1po/1po-bff-fe-spec/generated/my_clients_order/request/MyClientsOrderDetailRequest';
import { MyClientsOrderRequest } from '@1po/1po-bff-fe-spec/generated/my_clients_order/request/MyClientsOrderRequest';
import { CheckoutOrderRequest } from '@1po/1po-bff-fe-spec/generated/order/request/CheckoutOrderRequest';
import { DownloadDealerDeliveryTracksRequest } from '@1po/1po-bff-fe-spec/generated/order/request/DownloadDealerDeliveryTracksRequest';
import { GetDealerOrderPageRequest } from '@1po/1po-bff-fe-spec/generated/order/request/GetDealerOrderPageRequest';
import { GetOrderByIdRequest } from '@1po/1po-bff-fe-spec/generated/order/request/GetOrderByIdRequest';
import { ReAddOrderReferencesToBasketRequest } from '@1po/1po-bff-fe-spec/generated/order/request/ReAddOrderReferencesToBasketRequest';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { TWENTY_SEC, WebSocketAction } from 'utils/domainStore';
import { wsSendAction, wsSendActionNoTimeout } from 'utils/domainStore/api';

RequestResponseMappingManager.addMapping(CHECKOUT_ORDER_URL, CHECKOUT_ORDER_RESPONSE);
RequestResponseMappingManager.addMapping(GET_GARAGE_CLAIMS_URL, GET_GARAGE_CLAIM_RESPONSE);
RequestResponseMappingManager.addMapping(
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST,
  ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST_RESPONSE,
);
RequestResponseMappingManager.addMapping(GET_CURRENT_EXADIS_RETURN_LIST, GET_CURRENT_EXADIS_RETURN_LIST_RESPONSE);
RequestResponseMappingManager.addMapping(
  REMOVE_CLAIMED_ITEMS_FROM_EXADIS_RETURN_LIST,
  REMOVE_ITEMS_FROM_EXADIS_RETURN_LIST_RESPONSE,
);
RequestResponseMappingManager.addMapping(
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST,
  ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST_RESPONSE,
);
RequestResponseMappingManager.addMapping(GET_CURRENT_DEPOSIT_RETURN_LIST, GET_CURRENT_DEPOSIT_RETURN_LIST_RESPONSE);
RequestResponseMappingManager.addMapping(
  REMOVE_CLAIMED_ITEMS_FROM_DEPOSIT_RETURN_LIST,
  REMOVE_ITEMS_FROM_DEPOSIT_RETURN_LIST_RESPONSE,
);

export function sendCheckoutOrderRequest(request: CheckoutOrderRequest): WebSocketAction {
  // TWENTY_SEC as timeout, as there are multiple API calls to be performed
  return wsSendAction(CHECKOUT_ORDER_URL, request, TWENTY_SEC);
}

export function sendDownloadDealerDeliveryTracksRequest(request: DownloadDealerDeliveryTracksRequest): WebSocketAction {
  return wsSendAction(ORDER_LIST_DOWNLOAD_URL, request);
}

export function sendExternalOrderListRequest(): WebSocketAction {
  return wsSendAction(EXTERNAL_ORDER_LIST_GET_URL, null);
}

export function sendGetOrderById(request: GetOrderByIdRequest): WebSocketAction {
  return wsSendAction(ORDER_GET_BY_ID_URL, request);
}

export function sendReAddReferencesToBasket(request: ReAddOrderReferencesToBasketRequest): WebSocketAction {
  return wsSendAction(ORDER_RE_ADD_REFERENCES_TO_BASKET, request);
}

export function sendOrderClaim(request: CreateOrderClaimRequest): WebSocketAction {
  return wsSendAction(SEND_CLAIM_URL, request);
}

export function subscribeSap2bClaimsResponses(): WebSocketAction {
  return wsSendAction(GET_SEND_CLAIM_STATUS_URL, null);
}

export function sendGetClaimsRequest(request: GetGarageClaimPageRequest): WebSocketAction {
  return wsSendAction(GET_GARAGE_CLAIMS_URL, request);
}

export function sendGetAscOrders(request: AftersalesOrderRequest): WebSocketAction {
  return wsSendAction(AFTERSALESORDERS_GET_URL, request);
}

export function sendGetMyClientsOrders(request: MyClientsOrderRequest): WebSocketAction {
  return wsSendAction(MY_CLIENTS_ORDERS_GET_URL, request);
}

export function sendGetMyClientsOrderDetail(request: MyClientsOrderDetailRequest): WebSocketAction {
  return wsSendAction(MY_CLIENTS_ORDER_DETAIL_GET_URL, request);
}

export function sendGetClaimsAttachmentUploadUrl(request: AddCustomItemRequest): WebSocketAction {
  return wsSendAction(GET_CLAIM_ATTACHMENT_UPLOAD_URL, request);
}

export function sendGetClaimsAttachmentDownloadUrl(request: GetClaimAttachmentDownloadUrlRequest): WebSocketAction {
  return wsSendAction(GET_CLAIM_ATTACHMENT_DOWNLOAD_URL, request);
}

export function sendGetGarageUsersWithOrderRequest(): WebSocketAction {
  return wsSendAction(GET_GARAGE_USERS_WITH_ORDER_URL, null);
}

export function sendSubscribeOrderUpdates(request: GetDealerOrderPageRequest): WebSocketAction {
  return wsSendAction(SUBSCRIBE_ORDER_STATUS_UPDATES_URL, request);
}

export function sendUnsubscribeOrderUpdates(): WebSocketAction {
  return wsSendActionNoTimeout(UNSUBSCRIBE_ORDER_STATUS_UPDATES_URL, null);
}

export function sendAddAscOrderItemToExadisReturnListRequest(
  request: AddAscOrderItemToExadisReturnListRequest,
): WebSocketAction {
  return wsSendAction(ADD_ASC_ORDER_ITEM_TO_EXADIS_RETURN_LIST, request);
}

export function sendGetCurrentExadisReturnListRequest(request: GetCurrentExadisReturnListRequest): WebSocketAction {
  return wsSendAction(GET_CURRENT_EXADIS_RETURN_LIST, request);
}

export function sendRemoveItemsFromExadisReturnListRequest(
  request: RemoveItemsFromExadisReturnListRequest,
): WebSocketAction {
  return wsSendAction(REMOVE_CLAIMED_ITEMS_FROM_EXADIS_RETURN_LIST, request);
}

export function sendAddAscOrderItemToDepositReturnListRequest(
  request: AddAscOrderItemToDepositReturnListRequest,
): WebSocketAction {
  return wsSendAction(ADD_ASC_ORDER_ITEM_TO_DEPOSIT_RETURN_LIST, request);
}

export function sendGetCurrentDepositReturnListRequest(request: GetCurrentDepositReturnListRequest): WebSocketAction {
  return wsSendAction(GET_CURRENT_DEPOSIT_RETURN_LIST, request);
}

export function sendRemoveItemsFromDepositReturnListRequest(
  request: RemoveItemsFromDepositReturnListRequest,
): WebSocketAction {
  return wsSendAction(REMOVE_CLAIMED_ITEMS_FROM_DEPOSIT_RETURN_LIST, request);
}
